export type URLState = {
  panel?: boolean;
  id?: string | null;
  cx?: number; // center uTL [0..1]
  cy?: number; // center vTL [0..1]
  iz?: number; // image zoom
  f?: string[]; // faction filter
  seg?: string[]; // segmentum filter
  type?: string[]; // type filter
  cluster?: boolean; // clustering toggle
};

export function readURL(): URLState {
  const p = new URLSearchParams(window.location.search);
  const panelParam = p.get('panel');
  const clusterParam = p.get('cluster');
  return {
    panel: panelParam !== null ? panelParam === '1' : undefined,
    id: p.get('id') ?? undefined,
    cx: p.get('cx') ? Number(p.get('cx')) : undefined,
    cy: p.get('cy') ? Number(p.get('cy')) : undefined,
    iz: p.get('iz') ? Number(p.get('iz')) : undefined,
    f: p.get('f') ? p.get('f')!.split(',').filter(Boolean) : undefined,
    seg: p.get('seg') ? p.get('seg')!.split(',').filter(Boolean) : undefined,
    type: p.get('type') ? p.get('type')!.split(',').filter(Boolean) : undefined,
    cluster: clusterParam !== null ? clusterParam === '1' : undefined,
  };
}

export function writeURL(state: URLState) {
  const p = new URLSearchParams(window.location.search);
  if (state.panel !== undefined) p.set('panel', state.panel ? '1' : '0');
  if (state.id !== undefined) {
    if (state.id === null) p.delete('id');
    else p.set('id', state.id);
  }
  if (state.cx !== undefined && state.cy !== undefined) {
    p.set('cx', state.cx.toFixed(6));
    p.set('cy', state.cy.toFixed(6));
  }
  if (state.iz !== undefined) p.set('iz', state.iz.toFixed(4));
  if (state.f) p.set('f', state.f.join(','));
  if (state.seg) p.set('seg', state.seg.join(','));
  if (state.type) p.set('type', state.type.join(','));
  if (state.cluster !== undefined) {
    if (state.cluster) p.set('cluster', '1');
    else p.delete('cluster');
  }
  const nextQS = p.toString();
  const currentQS = window.location.search.replace(/^\?/, '');
  if (nextQS === currentQS) return; // no-op if unchanged
  const newUrl = `${window.location.pathname}?${nextQS}`;
  try {
    if (window.isSecureContext === false) return; // avoid in insecure contexts
    window.history.replaceState(null, '', newUrl);
  } catch (err) {
    // Swallow SecurityError (Firefox: "The operation is insecure") to avoid breaking the app
    // eslint-disable-next-line no-console
    console.warn('URL update skipped:', err);
  }
}
